import * as React from 'react';
import { connect } from 'react-redux';
import * as Models from './models/index';
import * as ActionCreators from './actions/action.creators';
import { Route, RouteProps, Switch, withRouter } from 'react-router-dom';
import LayoutBig from './layout.big';
import LayoutSmall from './layout.small';
import * as CallApi from './infrastructure/call.api';

import Login from './views/login/index';
import PasswordRecovery from './views/password recovery/index';
import PasswordExpiredOrForcedChange from './views/change password/index';
import YumSSOIdSelfService from './views/yum.sso.id.self.service';

interface StateProps {
	isMobileMode: boolean;
	showMessages: boolean;
}
interface DispatchProps {
	onLoad(config: Models.InitialData): any;
	changeBrowserRegistration(isBrowserRegistered: boolean): any;
	resetScreenSize(): any;
}
interface OwnProps {
	config: Models.InitialData;
}

interface GetRegistrationInfoResult {
	isValid?: boolean | null;
	description?: string | null;
	status?: string | null;
}
const mapStateToProps = (state: Models.StoreState): StateProps => ({
	isMobileMode: state.shell.isMobileMode,
	showMessages: state.messages.messages.length > 0,
});
const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
	onLoad: data => dispatch(ActionCreators.loadInitialData(data)),
	changeBrowserRegistration: data => dispatch(ActionCreators.changeBrowserRegistration(data)),
	resetScreenSize: () => dispatch(ActionCreators.resetScreenSize()),
});
export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(
		class Shell extends React.Component<StateProps & DispatchProps & OwnProps & RouteProps, {}> {
			routers: RouteProps[] = [
				{
					path: '/',
					exact: true,
					component: Login,
				},
				{
					path: '/password recovery',
					component: PasswordRecovery,
				},
				{
					path: '/password expired',
					component: PasswordExpiredOrForcedChange,
				},
				{
					path: '/forced change password',
					component: PasswordExpiredOrForcedChange,
				},
				{
					path: '/yum_sso_id_self_service',
					component: YumSSOIdSelfService,
				},
				{
					path: '*',
					component:  Login
				},
			];

			componentWillMount() {
				this.props.resetScreenSize();
			}

			async getBrowserRegistration() {
				try {
					const response = await CallApi.api.get<GetRegistrationInfoResult>(
						`${this.props.config.clockEntryUrl}/CE_Registration/GetRegistrationInfo?v2`
					);
					this.props.changeBrowserRegistration(response.isValid);
				} catch (error) {
					console.log('Error in getBrowserRegistration', error);
				}
			}

			componentDidMount() {
				this.props.onLoad(this.props.config);
				if (this.props.config.clockEntryUrl) this.getBrowserRegistration();

				window.addEventListener('resize', () => {
					this.props.resetScreenSize();
				});
			}

			render() {
				const isFrontPage = this.props.location.pathname === '/';

				const Layout = this.props.isMobileMode ? LayoutSmall : LayoutBig;

				return (
					<Layout showMessages={isFrontPage ? this.props.showMessages : false}>
						<Switch>
							{this.routers.map((route) => (
								<Route key={route.path} {...route} />
							))}
						</Switch>
					</Layout>
				);
			}
		}
	)
);
